var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWelcomeAboard = function SvgWelcomeAboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M40 10c7.5 8.5 12 19.5 12 32v8H28v-8c0-12.5 4.5-23.5 12-32m0 16a5 5 0 1 0 0 10 5 5 0 0 0 0-10",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m27 43-8 10v7l9-9zM53 43l8 10v7l-9-9zM33 52h14l-7 18z"
  })));
};
export default SvgWelcomeAboard;